import ReactDOM from 'react-dom/client';
import React from 'react';
import { v2Component } from '../../../index';
import { TenantContext } from '../../../context/tenant-context';
import { ToastContainer } from 'react-toastify';
import { ProductPlaceholder } from './product-placeholder';

export function initProductPlaceholder(element?: HTMLElement) {
  const elements = element !== undefined ? [element] : document.getElementsByName('product-placeholder-upload-v2');

  elements.forEach((element) => {
    if (element.getAttribute('initialized') !== 'true') {
      element.setAttribute('initialized', 'true');
      const root = ReactDOM.createRoot(element);
      const bootstrap = () => {
        const { tenant, contextPath, ...dataset } = Object.assign({}, element.dataset) as any;
        const props = {
          ...dataset,
        };

        root.render(
          v2Component(
            <TenantContext.Provider value={{ tenant, contextPath, spaMode: false }}>
              <ToastContainer />
              <ProductPlaceholder {...props} />
            </TenantContext.Provider>,
          ),
        );
      };
      bootstrap();
    }
  });
}
